export class Change {
    fieldName: string;
    oldValue: string;
    newValue: string;
    description: string;
    additionalDescription: string;
    formatterType: string;
}
